/**
 * Import global things:
 */

import Vue from 'vue'
import { Slideshow } from './slideshows' // the main Vue instance
import { EventManager, Axios } from './utils'

// these exports are available globaly through window.metaslider.app.{name}
export { Vue, Slideshow, EventManager, Axios }



// WEBPACK FOOTER //
// ./src/admin/assets/js/app/app.js